<template>
    <div v-if="haveInit">
        <div
            slot="content"
            class="operate-content"
        >
            <template>
                <el-alert
                    v-if="(isFromOperateDetail && hasPurchaseSubmitContent) || isAudit"
                    :title="approvalInfoMsg"
                    type="warning"
                    :center="true"
                />
            </template>
            <div
                v-if="isFromOperateDetail && showAuditInfo"
            >
                <xx-audit-flow
                    :ajax="{
                        url: '/api/vss/shepherd/product/listApplyAuditTasks',
                        params: {
                            applyId: logApplyId
                        }
                    }"
                    :scene="-1"
                    :business-key="logApplyId"
                />
                <h3 class="row-header">
                    审批日志
                </h3>
                <auditLog
                    :apply-id="logApplyId"
                />
            </div>
            <xx-form
                ref="form"
                :model="form"
                :rules="formRules"
                label-width="124px"
                label-suffix=":"
                class="max-width-900 w-full"
            >
                <!-- 新品提报页，不展示基础信息 -->
                <template v-if="!isCreateNewRefer">
                    <h3 class="row-header">
                        基本信息
                    </h3>
                    <xx-form-item
                        size="mini"
                        label="SKU ID"
                    >
                        {{ skuInfo.skuId }}
                    </xx-form-item>
                    <xx-form-item
                        size="mini"
                        label="SKU名称"
                    >
                        {{ skuInfo.skuName }}
                    </xx-form-item>
                    <xx-form-item
                        size="mini"
                        label="管理类目"
                    >
                        {{ skuInfo.categoryName }}
                    </xx-form-item>
                    <xx-form-item
                        size="mini"
                        label="后台类目"
                    >
                        {{ skuInfo.bgCategoryName }}
                    </xx-form-item>
                    <xx-form-item
                        size="mini"
                        label="品牌"
                    >
                        {{ skuInfo.brandName }}
                    </xx-form-item>
                    <xx-form-item
                        size="mini"
                        label="规格"
                    >
                        {{ skuInfo.specActual }}
                    </xx-form-item>
                </template>
                <h3 class="row-header">
                    运营信息
                </h3>
                <template v-if="isSupplierEditAgain">
                    <xx-form-item
                        v-if="mode === 'edit'"
                        label="供货规则"
                        prop="supplierId"
                    >
                        <supplier-name
                            v-model="form.supplierId"
                            @loaded="onSupplierListLoaded"
                            @change="onSupplierChange"
                        />
                        <!-- 详情页不展示 -->
                        <!-- <span v-else>
                            {{ form.supplierName }}
                        </span> -->
                    </xx-form-item>
                    <xx-form-item
                        v-if="mode === 'edit'"
                        label="采购mis号"
                        prop="purchaserMis"
                    >
                        <el-input
                            v-model="form.purchaserMis"
                            placeholder="请填写采购mis号"
                        />
                        <!-- <span v-else>
                            {{ form.purchaserMis }}
                        </span> -->
                    </xx-form-item>
                </template>
                <xx-form-item
                    label="副标题"
                    prop="subTitle"
                    class="is-required"
                >
                    <!-- 权限：芥末-基础库-详情页-修改运营信息 -->
                    <el-input
                        v-if="mode==='edit'"
                        v-model="form.subTitle"
                        class="sub-title-input"
                        :disabled="judgeAttrUnderReview(modifiyAttrs, 'subTitle') || MixinJudgeRejectedAttrsDisabled('subTitle')"
                        :maxlength="44"
                        placeholder="请输入副标题"
                    />
                    <span v-else>{{ form.subTitle | labelEmptyFilter }}</span>
                    <word-count
                        v-if="mode==='edit'"
                        :value="form.subTitle"
                        limit="44"
                    />
                    <div
                        v-if="mode==='edit'"
                        style="color: #585D66;"
                    >
                        使用中文标点符号，句中不能使用句号、中括号等，句末不加标点
                        <xx-link>
                            <example-pic
                                type="subTitle"
                                text="查看示例"
                            />
                        </xx-link>
                    </div>
                </xx-form-item>
                <xx-form-item
                    label="商品卖点"
                    prop="skuSellPointContentList"
                    class="is-required"
                >
                    <!-- 权限：芥末-基础库-详情页-修改运营信息 -->
                    <sellPanel
                        v-model="form.skuSellPointContentList"
                        :editable="mode === 'edit'"
                        :need-drag="mode === 'edit'"
                        :sku-base-id="form.skuBaseId"
                        :disabled="judgeAttrUnderReview(modifiyAttrs, 'skuSellPointContentList') || MixinJudgeRejectedAttrsDisabled('skuSellPointContentList')"
                    />
                    <div
                        v-if="mode === 'edit'"
                        class="text-info"
                    >
                        未找到合适的卖点？<xx-link
                            path="https://tt.sankuai.com/maicaishiyebu/create?cid=569&tid=5297&iid=24823"
                        >
                            前往申请
                        </xx-link>
                        ，若无法操作申请，请联系采购，让采购申请
                    </div>
                    <div
                        v-if="mode==='edit'"
                        class="text-info"
                    >
                        至少填写两个卖点信息，优先填写用户关注的核心商品卖点
                        <xx-link>
                            <example-pic
                                type="sellingPoints"
                                text="查看示例"
                            />
                        </xx-link>
                    </div>
                </xx-form-item>
                <xx-form-item
                    label="列表用图"
                    prop="lbPicture"
                    class="is-required"
                >
                    <div
                        v-if="mode==='edit'"
                    >
                        <div class="text-info">
                            1、单图最大不得超过10MB；仅支持JPG、PNG格式；需为白底图
                        </div>
                        <div class="text-info">
                            2、为了保证展示效果最佳，上传的图片会经过AI自动裁切部分白边
                            <xx-link>
                                <example-pic
                                    type="lbPictures"
                                    text="查看示例"
                                />
                            </xx-link>
                        </div>
                    </div>
                    <div
                        class="lb-picture-container"
                        :class="{'no-picture': !form.lbPicture}"
                    >
                        <!-- 权限：芥末-基础库-详情页-修改运营信息 -->
                        <ImageUpload
                            v-if="mode==='edit' || form.lbPicture"
                            :max-pic="1"
                            :mode="mode==='edit' ? 'single' : 'show'"
                            desc="添加本地图片"
                            :validate-rule="lbValidateRule"
                            :can-delete="true"
                            :value="(form.lbPicture&&form.lbPicture.picUrl)||''"
                            :dg-water-mark="true"
                            :white-pic-adjust="true"
                            :disabled="judgeAttrUnderReview(modifiyAttrs, 'skuListPicture') || MixinJudgeRejectedAttrsDisabled('lbPicture')"
                            @addSuccessSingle="handleLbAddSuccess"
                            @modifySuccessSingle="handleLbModifySuccess"
                            @remove="handleLbDelete"
                        />
                        <span v-else>无</span>
                    </div>
                </xx-form-item>
                <xx-form-item label="动态列表图">
                    <!-- 权限：芥末-基础库-详情页-修改运营信息 -->
                    <div
                        v-if="mode==='edit'"
                        class="text-info"
                    >
                        {{ `分辨率为${operatePicInfo.DLB_WIDTH}*${operatePicInfo.DLB_HEIGHT}；单图最大不得超过${operatePicInfo.DLB_MAXSIZE}kb; 仅支持GIF格式；` }}
                    </div>
                    <div class="product-picture-container">
                        <ImageUpload
                            v-if="mode==='edit' || form.dlbPicture"
                            :max-pic="1"
                            :mode="mode==='edit' ? 'single' : 'show'"
                            desc="添加本地图片"
                            :validate-rule="dlbValidateRule"
                            :can-delete="true"
                            :disabled="MixinJudgeRejectedAttrsDisabled('dlbPicture')"
                            :value="(form.dlbPicture&&form.dlbPicture.picUrl)||''"
                            @addSuccess="handleDlbSuccess"
                            @modifySuccess="handleDlbSuccess"
                            @remove="handleDlbDelete"
                        />
                        <span v-else>无</span>
                    </div>
                </xx-form-item>
                <xx-form-item label="商品短视频">
                    <div class="product-video-container">
                        <!-- 权限：芥末-基础库-详情页-修改运营信息 -->
                        <VideoUpload
                            v-if="mode==='edit'"
                            v-model="videoComp"
                            :validate-rule="videodateRule"
                            desc="`将文件拖到此处，或<em>点击上传</em>`"
                            :tip="tip"
                            :ext-data="{validCode:'h264'}"
                            :pixel-size-limit="pixelSize"
                            class="upload-video"
                            :disabled="MixinJudgeRejectedAttrsDisabled('video')"
                        />
                        <video
                            v-else-if="form.video"
                            class="video"
                            :src="form.video ? form.video.picUrl : ''"
                            controls
                            :disabled="MixinJudgeRejectedAttrsDisabled('video')"
                        ></video>
                    </div>
                </xx-form-item>
                <xx-form-item
                    label="商品主图"
                    prop="skuPictureList"
                    class="is-required"
                >
                    <div class="main-picture">
                        <div class="flex-column-container">
                            <span>示例图</span>
                            <xx-image
                                class="sample"
                                src="https://p0.meituan.net/mallimages/4ee3660880998e2de49c87f81f73954b1367321.jpg"
                                :preview-src-list="['https://p0.meituan.net/mallimages/4ee3660880998e2de49c87f81f73954b1367321.jpg']"
                            />
                        </div>
                        <!-- 权限：芥末-基础库-详情页-修改运营信息 -->
                        <div>
                            <DragFileUpload
                                v-if="mode ==='edit' || form.skuPictureList.length"
                                ref="dragfileupload"
                                :key="skuPictureKey"
                                :disabled="judgeAttrUnderReview(modifiyAttrs, 'skuMainPictureList') || MixinJudgeRejectedAttrsDisabled('skuPictureList')"
                                :value="form.skuPictureList.map(item=>item.picUrl)"
                                :show-only="mode==='show'"
                                desc="添加图片"
                                :max-pic="6"
                                :row-count="5"
                                :margin="5"
                                style="width:750px;margin-top:33px"
                                :is-validate="true"
                                :dg-water-mark="true"
                                :validate-rule="skuPictureListRule"
                                @input="skuPictureListInput"
                            />
                            <span v-else>无</span>
                        </div>
                    </div>
                    <div
                        v-if="mode ==='edit'"
                        class="main-picture-describe"
                    >
                        <div
                            class="text-info"
                        >
                            支持最少5张，最多6张主图，分辨率为800*800; 单图最大不得超过2M；仅支持GIF、JPG、PNG格式；
                            商品主图第一张需与列表图保持一致为白底图，其他图参照商品图规范
                            <xx-link>
                                <example-pic
                                    type="skuPictureList"
                                    text="查看示例"
                                />
                            </xx-link>
                        </div>
                    </div>
                </xx-form-item>
                <xx-form-item
                    label="小贴士"
                    prop="tipsPicture"
                >
                    <div class="main-picture">
                        <!-- 校验规则和商品主图保持一致 -->
                        <!-- v-if逻辑和营养图保持一致 -->
                        <!-- disabled逻辑与商品主图保持一致 -->
                        <ImageUpload
                            v-if="mode ==='edit' || form.tipsPicture"
                            :max-pic="1"
                            :mode="mode ==='edit' ? 'single' : 'show'"
                            desc="添加本地图片"
                            :validate-rule="skuPictureListRule"
                            :can-delete="true"
                            :value="form.tipsPicture && form.tipsPicture.picUrl"
                            :disabled="judgeAttrUnderReview(modifiyAttrs, 'skuMainPictureList') || MixinJudgeRejectedAttrsDisabled('skuPictureList')"
                            @addSuccessSingle="handleTipsPictureAddOrModify"
                            @modifySuccessSingle="handleTipsPictureAddOrModify"
                            @remove="handleTipsPictureDelete"
                        />
                        <span v-else>无</span>
                        <div
                            v-if="mode==='edit'"
                            class="ml-10"
                            style="color: red"
                        >
                            <p>
                                勿动，平台内部管理使用
                            </p>
                        </div>
                    </div>
                </xx-form-item>
                <xx-form-item
                    label="营养成分/配料表图"
                    prop="yyPicture"
                >
                    <div
                        class="main-picture"
                    >
                        <div class="flex-column-container">
                            <span>示例图</span>
                            <xx-image
                                :append-to-body="true"
                                class="sample"
                                src="https://s3plus.meituan.net/v1/mss_915cfe67c99b4651b81ca210670f9302/mall-fe-files/小象超市营养成分表规范20221114.jpg"
                                :preview-src-list="['https://s3plus.meituan.net/v1/mss_915cfe67c99b4651b81ca210670f9302/mall-fe-files/小象超市营养成分表规范20221114.jpg']"
                                :disabled="judgeAttrDisabled('skuMainPictureList')"
                            />
                        </div>
                        <div class="flex-column-container">
                            <span style="width:130px">营养成分/配料表图</span>
                            <!-- 权限：芥末-基础库-详情页-修改运营信息 -->
                            <ImageUpload
                                v-if="mode==='edit' || form.yyPicture"
                                :max-pic="1"
                                :mode="mode==='edit' ? 'single' : 'show'"
                                desc="添加本地图片"
                                :disabled="judgeAttrUnderReview(modifiyAttrs, 'skuMainPictureList') || MixinJudgeRejectedAttrsDisabled('yyPicture')"
                                :validate-rule="nutritionValidateRule"
                                :can-delete="true"
                                :value="form.yyPicture && form.yyPicture.picUrl"
                                @addSuccessSingle="nutritionHandleLbAddSuccess"
                                @modifySuccessSingle="nutritionHandleLbModifySuccess"
                                @remove="nutritionHandleLbDelete"
                            />
                            <span v-else>无</span>
                        </div>
                        <div
                            v-if="mode==='edit'"
                            class="nutrition-picture-describe mt-33 text-info"
                        >
                            <p>
                                <xx-link
                                    path="https://s3plus.meituan.net/v1/mss_915cfe67c99b4651b81ca210670f9302/mall-fe-files/配料营养表PSD源文件.zip"
                                    target="_self"
                                >
                                    下载PSD制图模板
                                </xx-link>
                            </p>
                            <p style="width:500px">
                                限1张, 图片宽度限800, 高度不限; 最大不超过2M; 仅支持JPG、PNG格式;
                            </p>
                        </div>
                    </div>
                </xx-form-item>
                <xx-form-item
                    label="商品详情"
                    prop="mediumDescription"
                    class="is-required"
                >
                    <div
                        v-for="(item, index) in Object.keys(describeShowSequence)"
                        :key="`${item}-${index}`"
                    >
                        <div
                            style="position: relative; margin-bottom: 40px;"
                            :class="{
                                'first-child': index === 0,
                                'last-child': index === Object.keys(describeShowSequence).length - 1
                            }"
                        >
                            <div style="position: absolute; top: -40px; left: -45px;">
                                <span
                                    v-if="item === 'mediumDescription'"
                                    style="color: red"
                                >
                                    *
                                </span>
                                {{ describeShowSequence[item].title }}
                            </div>
                            <div
                                v-for="(child, idx) in describeShowSequence[item].promptText"
                                :key="`${child}-${idx}`"
                                :style="{ position: 'absolute', top: `${-40 + idx * 15}px`, color: `${['topDescription', 'bottomDescription'].includes(item) && idx === 0 ? 'red' : 'black'}`}"
                            >
                                <div v-if="mode === 'edit'">
                                    {{ child }}
                                </div>
                            </div>
                            <describe
                                v-model="form[item]"
                                :resource-type="describeShowSequence[item].resourceType"
                                :show="mode === 'show' || judgeAttrUnderReview(modifiyAttrs, 'description') || MixinJudgeRejectedAttrsDisabled('description')"
                                :sku-base-info="form"
                                :dg-water-mark="true"
                                :limit="describeShowSequence[item].limit"
                                @modify-success="handleDescriptionSuccess"
                            />
                        </div>
                    </div>
                </xx-form-item>
            </xx-form>
        </div>
        <div
            v-if="!isCreateNewRefer"
            slot="bottom-fixed"
            class="footer"
        >
            <template v-if="mode==='edit'">
                <el-button
                    size="small"
                    :disabled="loading"
                    @click="goToList"
                >
                    取消
                </el-button>
                <el-button
                    type="primary"
                    size="small"
                    :loading="loading"
                    :disabled="hasPurchaseSubmitContent === 1"
                    @click="onSubmit"
                >
                    提交
                </el-button>
                <!-- 提交提示信息：OCR识别(主图) -->
                <confirm-dialog
                    ref="confirmDialog"
                    zt-pic-valid
                    lb-white-bg-pic-valid
                    zt-white-bg-pic-valid
                    @success="onConfirmSuccess"
                    @cancel="loading = false"
                />
            </template>
            <template v-else>
                <el-button
                    size="small"
                    :disabled="loading"
                    @click="goToList"
                >
                    关闭
                </el-button>
            </template>
        </div>
    </div>
    <span v-else>loading...</span>
</template>

<script>
/* eslint-disable import/no-unresolved */
import ImageUpload from 'components/ImageUpload';
import DragFileUpload from 'components/DragFileUpload';
import WordCount from 'components/WordCount';
import { operatePicTypeEnum, operatePicInfo } from 'utils/enum';
import { ExtBusinessTypeMap } from 'utils/dataMap';
import judgeAttrUnderReview from 'utils/spAttrsApprove';
import Rules from '@lsfe/rules';
import ExamplePic from './createNewProduct/components/ExamplePicDialog';
import ConfirmDialog from './createNewProduct/components/ConfirmDialog';
import MixinJudgeRejectedAttrsDisabled from './createNewProduct/mixins/rejectedDisabled';
import Describe from './describe';
import sellPanel from './sellPanel';
import auditLog from './auditLog';
import {
    skuPictureListInput, imgUrlTransformObject, imgIsGif,
} from './utils';
import {
    defaultForm, lbValidateRule, dlbValidateRule, videodateRule, skuPictureListRule, NOMAL_WIDTH, NOMAL_HEIGHT, nutritionValidateRule,
} from './config';
import SupplierName from './SupplierName';

function loadImageAsync(url) {
    return new Promise(((resolve, reject) => {
        const image = new Image();
        image.src = url;
        image.onload = function () {
            resolve(image);
        };
        image.onerror = function () {
            reject(new Error(`load image fail:${url}`));
        };
    }));
}

async function updatePicSize(picList) {
    const res = await Promise.all((picList || []).map((item) => loadImageAsync(item.picUrl).catch(() => null)));
    res.forEach((image, idx) => {
        if (image) {
            picList[idx].width = image.width;
            picList[idx].height = image.height;
        }
    });
    return res;
}

const topDescription = {
    title: '顶部：',
    promptText: [
        '勿动，平台内部管理使用，配置图片后将在顶部展示',
        '图片规则：宽度大于720px；单图文件最大500KB；仅支持GIF、JPG、PNG格式；最多2张图；不允许使用广告违禁词',
    ],
    resourceType: 1,
    limit: 2,
};
const mediumDescription = {
    title: '中部：',
    promptText: [
        '图片规则：宽度大于720px；单图文件最大500KB；仅支持GIF、JPG、PNG格式；最多30张图；不允许使用广告违禁词',
    ],
    resourceType: 2,
    limit: 30,
};
const bottomDescription = {
    title: '底部：',
    promptText: [
        '勿动，平台内部管理使用，配置图片后将在底部展示',
        '图片规则：宽度大于720px；单图文件最大500KB；仅支持GIF、JPG、PNG格式；最多2张图；不允许使用广告违禁词',
    ],
    resourceType: 3,
    limit: 2,
};

export default {
    name: 'OperateContent',
    components: {
        ImageUpload,
        Describe,
        sellPanel,
        DragFileUpload,
        auditLog,
        ExamplePic,
        WordCount,
        SupplierName,
        ConfirmDialog,
    },
    inject: {
        // 默认来自新品提报页面
        from: { default: 'createNew' },
    },
    filters: {
        labelEmptyFilter: (val) => (!val || val === '' ? '无' : val),
    },
    mixins: [MixinJudgeRejectedAttrsDisabled],
    props: {
        isFromOperateDetail: {
            type: Boolean,
            default: false,
        },
        isContentSectionRequired: {
            type: Boolean,
            default: false,
        },
        refer: {
            type: String,
            default: 'operateManagePage',
        },
        skuId: {
            type: [String, Number],
            default: '',
        },
        spuId: {
            type: [String, Number],
            default: '',
        },
        mode: {
            type: String,
            default: 'show',
        },
        contentEditApplyId: {
            type: [String, Number],
            default: '',
        },
        applyId: {
            type: [String, Number],
            default: '',
        },
        businessKey: {
            type: [String, Number],
            default: '',
        },
        outerRules: {
            type: Object,
            default: () => ({}),
        },
        // 内容信息供应商2次编辑
        isSupplierEditAgain: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            form: defaultForm(),
            skuInfo: {
                skuId: '',
                skuName: '',
                categoryId: 0,
                categoryName: '',
                bgCategoryId: '',
                bgCategoryName: '',
                specActual: '',
                brandName: '',
            },
            loadTime: 0,
            lbValidateRule,
            dlbValidateRule,
            skuPictureListRule,
            videodateRule,
            nutritionValidateRule,
            operatePicInfo,
            tip: '支持的格式：视频编码为H264的MP4，单个文件大小不超过30M，视频分辨率至少为720p(1280✖️720像素)',
            pixelSize: {
                width: 1280,
                height: 720,
            },
            ExtBusinessTypeMap,
            loading: false,
            haveInit: false,
            approvalInfoMsg: '',
            skuPictureKey: 'forCreateNew',
            hasPurchaseSubmitContent: 0, // 是否有采购提交的内容修改：1-有，0-无
            originalModifiyAttrs: [],
            modifiyAttrs: [], // 审核字段
            cannotChangedFields: [],
            isAudit: false, // 历史逻辑
            version: '',
            ztGifNum: 0,
            nutritionHeight: null, // 营养图高度
        };
    },
    computed: {
        formRules() {
            if ((this.refer === 'createNewPage' && this.isContentSectionRequired) || this.refer === 'operateManagePage') {
                return {
                    supplierId: [
                        Rules.isRequired('供货规则必填'),
                    ],
                    purchaserMis: [
                        Rules.isRequired('采购mis号必填'),
                    ],
                    subTitle: [
                        Rules.isRequired('副标题必填'),
                        Rules.lenRange({ max: 44 }, '最多44个字'),
                    ],
                    skuSellPointContentList: [
                        Rules.isRequired('商品卖点必填'),
                        Rules.lenRange({ min: 2, max: 6 }, '商品卖点至少填写2个，至多填写6个'),
                    ],
                    lbPicture: [
                        Rules.isRequired('列表用图必填'),
                    ],
                    skuPictureList: [
                        Rules.isRequired('商品主图必填'),
                        Rules.lenRange({ min: 1 }, '商品主图必填'),
                    ],
                    mediumDescription: [
                        Rules.isRequired('商品详情-中部必填'),
                    ],
                };
            } else {
                return {
                    ...this.outerRules,
                    mediumDescription: [
                        Rules.isRequired('商品详情-中部必填'),
                    ],
                };
            }
        },
        logApplyId() {
            const data = this.isFromOperateDetail ? this.contentEditApplyId : this.applyId;
            return data;
        },
        // 来源自提报页面
        isCreateNewRefer() {
            return this.refer === 'createNewPage';
        },
        videoComp: {
            get() {
                const video = { url: null, name: '视频文件' };
                video.url = this.form.video && this.form.video.picUrl;
                return video;
            },
            set(nVal) {
                if (nVal && nVal.url) {
                    const picUrl = nVal.url;
                    this.form.video = {
                        picUrl,
                        id: null,
                        pictureType: operatePicTypeEnum.VIDEO_TYPE,
                        sequence: 0,
                        width: operatePicInfo.NOMAL_WIDTH,
                        height: operatePicInfo.NOMAL_WIDTH,
                    };
                } else {
                    this.form.video = null;
                }
            },
        },
        innerMode() {
            // 被新品提报引用，且被品控驳回(白名单)，不可编辑
            if (this.isCreateNewRefer && this.MixinJudgeRejectedAttrsDisabled('extAttrOperateInfo')) {
                return 'show';
            }
            return this.mode;
        },
        showAuditInfo() {
            return Boolean(+this.contentEditApplyId);
        },
        // 详情图-中部显示， 详情图-顶部、详情图-底部有值时显示
        describeShowSequence() {
            return {
                ...(this.form.topDescription ? { topDescription } : {}),
                ...{ mediumDescription },
                ...(this.form.bottomDescription ? { bottomDescription } : {}),
            };
        },
    },
    async created() {
        if (this.isCreateNewRefer) {
            this.haveInit = true;
        } else {
            await this.getProductBaseApprove();
            this.haveInit = false;
            await this.getDetail();
            this.haveInit = true;
        }
    },
    methods: {
        // 获取内容详情
        async getDetail() {
            try {
                const params = {
                    skuId: this.skuId,
                    spuId: this.spuId,
                    applyId: this.isSupplierEditAgain ? this.businessKey : this.contentEditApplyId,
                };
                const {
                    skuContent, cannotChangedFields, skuInfo, loadTime, hasPurchaseSubmitContent, version,
                } = await this.$hPost(this.isSupplierEditAgain ? '/api/vss/shepherd/VssContentApplyTService/queryContentApplyDetail' : '/api/vss/shepherd/product/queryModifySkuContentDetail', params);
                this.hasPurchaseSubmitContent = hasPurchaseSubmitContent;
                this.approvalInfoMsg = '当前内容信息已有审批中数据，请联系对应采购';
                if (this.isFromOperateDetail && Array.isArray(cannotChangedFields) && cannotChangedFields.length) {
                    this.isAudit = true;
                    this.cannotChangedFields = cannotChangedFields.map((item) => item.fieldName);
                }
                // 头部sku基本信息，不需要编辑
                this.skuInfo = skuInfo;
                // 初始化form数据
                this.handleForm(skuContent);
                // 防重复提交
                this.loadTime = loadTime;
                this.version = version;
            } catch (err) {
                this.$message.error(err.msg || err.message || '获取详情失败');
            }
        },
        filterDescriptionByType(descriptionArray, resourceType) {
            const filteredArray = descriptionArray.filter((item) => item.resourceType === resourceType);
            return filteredArray.length > 0 ? JSON.stringify(filteredArray) : '';
        },
        // 详情接口 -> 初始化表单
        handleForm(data) {
            const result = defaultForm();
            if (data) {
                // 批量赋值表单数据
                Object.keys(result).forEach((key) => {
                    if (data[key]) {
                        result[key] = data[key];
                    }
                });
                // 从后端返回的数据中区分主图和营养图
                // (data.ztPictureList || []).forEach((item) => {
                //     // 主图回显
                //     if (item.pictureContentType === 1) {
                //         data.ztPictureList.pop(item);
                //         // 营养图回显
                //         result.yyPicture = item;
                //     }
                // });
                // 适配表单数据
                result.skuBaseId = data.skuId || '';
                // 根据pictureContentType字段区分主图（-1）、主图-小贴士（2）、营养图（1）
                result.yyPicture = (data.ztPictureList || []).filter((item) => item.pictureContentType === 1)?.[0]; // 只有一张
                result.tipsPicture = (data.ztPictureList || []).filter((item) => item.pictureContentType === 2)?.[0]; // 只有一张
                // pictureContentType为-1或不存在的数据都归结为主图数据
                result.skuPictureList = (data.ztPictureList || []).filter((item) => item.pictureContentType === -1 || !item.pictureContentType)?.map((child) => ({
                    ...child,
                    pictureContentType: -1,
                }));
                const descriptionArray = (data.description ? JSON.parse(data.description) : []).filter((item) => item.url)?.map((child) => ({
                    ...child,
                    resourceType: child.resourceType || 2, // 历史的商品详情都是“商详-中” -> 返回值中无该字段时，进行补充
                }));
                // 商品详情信息
                result.topDescription = this.filterDescriptionByType(descriptionArray, 1); // 商品详情顶部信息
                result.mediumDescription = this.filterDescriptionByType(descriptionArray, 2); // 商品详情中部信息
                result.bottomDescription = this.filterDescriptionByType(descriptionArray, 3); // 商品详情底部信息
            }

            this.form = result;
            // 在详情加载之后，再绑定监听；当主图变化时，同步更新外卖图
            this.$watch('form.skuPictureList', (newVal) => {
                this.updateField('wmPictureList', this.updateWmPicList(newVal));
            });
        },
        // 判断传入的属性是否是当前正在审核的属性
        judgeAttrUnderReview(modifiyAttrs, attrName) {
            judgeAttrUnderReview(modifiyAttrs, attrName);
        },
        updateField(prop, value) {
            this.form[prop] = value;
            this.$refs.form.validate();
        },
        // 统一处理列表图成功
        onLbSuccess({ originalUrl, whitePicAdjustUrl, whitePicWideUrl }, index, type) {
            this.updateField('lbPicture', imgUrlTransformObject({
                picUrl: whitePicAdjustUrl || originalUrl,
                originalPicUrl: originalUrl,
                type: operatePicTypeEnum.LB_TYPE,
                height: NOMAL_HEIGHT,
                sequence: index,
            }));
            // 手动同步外卖侧用图
            this.syncWmFirstPicture({ picUrl: whitePicAdjustUrl || originalUrl, type, wmDataHasNoError: this.wmDataHasNoError() });
            // 添加同步至商品主图
            this.synchronousPictureList({ picUrl: whitePicWideUrl || whitePicAdjustUrl || originalUrl, type });
        },
        // 列表图添加成功
        handleLbAddSuccess({
            originalUrl, whiteBorderUrl, whitePicAdjustUrl, whitePicWideUrl,
        }, index) {
            this.onLbSuccess({
                originalUrl, whiteBorderUrl, whitePicAdjustUrl, whitePicWideUrl,
            }, index, 'add');
        },
        // 列表图修改成功
        handleLbModifySuccess({
            originalUrl, whiteBorderUrl, whitePicAdjustUrl, whitePicWideUrl,
        }, index) {
            this.onLbSuccess({
                originalUrl, whiteBorderUrl, whitePicAdjustUrl, whitePicWideUrl,
            }, index, 'modify');
        },
        // 列表图删除
        handleLbDelete() {
            this.form.skuPictureList.forEach((item, index) => {
                if (item.picUrl === this.form.lbPicture.picUrl) {
                    this.form.skuPictureList.splice(index, 1);
                    this.$refs.dragfileupload.initImgArray(this.form.skuPictureList.map((items) => items.picUrl));
                }
            });
            this.updateField('lbPicture', null);
            const item = this.form.wmPictureList.find(
                // eslint-disable-next-line no-shadow
                (item) => +item.sequence === 0,
            );
            if (item) {
                // 数据正常的情况(fix先添加主图再删外卖图会有问题)
                this.form.wmPictureList.shift();
            }
        },
        // 统一处理营养成分图成功
        onNutritionSuccess({ originalUrl, whiteBorderUrl, whitePicAdjustUrl }, index, type) {
            // 这里本地进不到if里, 泳道上是可以的
            if (originalUrl || whiteBorderUrl || whitePicAdjustUrl) {
                this.updateField('yyPicture', imgUrlTransformObject({
                    picUrl: originalUrl || whiteBorderUrl || whitePicAdjustUrl,
                    originalPicUrl: originalUrl,
                    sequence: index,
                    height: this.nutritionHeight,
                    type: operatePicTypeEnum.ZT_TYPE,
                    pictureContentType: 1, // 表明是营养图
                }));
                // 手动同步外卖侧用图
                this.syncWmFirstPicture({
                    picUrl: originalUrl || whiteBorderUrl || whitePicAdjustUrl, type, wmDataHasNoError: this.wmDataHasNoError(), pictureContentType: 1,
                });
            }
        },
        // 添加营养成分图
        nutritionHandleLbAddSuccess({
            originalUrl, whiteBorderUrl, whitePicAdjustUrl, height,
        }, index) {
            // 保存营养图高度,提交的时候营养图合并到主图时需要
            this.nutritionHeight = height;
            this.onNutritionSuccess({
                originalUrl, whiteBorderUrl, whitePicAdjustUrl, height,
            }, index, 'addTail');
        },
        // 修改营养成分图
        nutritionHandleLbModifySuccess({
            originalUrl, whiteBorderUrl, whitePicAdjustUrl, height,
        }, index) {
            this.nutritionHeight = height;
            this.onNutritionSuccess({
                originalUrl, whiteBorderUrl, whitePicAdjustUrl, height,
            }, index, 'modifyTail');
        },
        // 删除营养成分图
        nutritionHandleLbDelete() {
            const item = this.form.wmPictureList.find(
                // eslint-disable-next-line no-shadow
                (item) => +item.sequence === 0,
            );
            this.updateField('yyPicture', null);
            if (item) {
                // 数据正常的情况(fix先添加主图再删外卖图会有问题)
                this.form.wmPictureList.pop();
            }
        },
        // 统一处理商品主图-小贴士（小贴士只能上传1张，因此index恒定为0，直接用updateField方法更新表单相应字段即可，不需要更新表单相应字段的第index项）
        handleTipsPictureSuccess({
            originalUrl, whiteBorderUrl, whitePicAdjustUrl, height, width,
        }) {
            if (originalUrl || whiteBorderUrl || whitePicAdjustUrl) {
                this.updateField('tipsPicture', imgUrlTransformObject({
                    picUrl: originalUrl || whiteBorderUrl || whitePicAdjustUrl,
                    originalPicUrl: originalUrl,
                    type: operatePicTypeEnum.ZT_TYPE,
                    pictureContentType: 2, // 表明是小贴士
                    height,
                    width,
                }));
            }
        },
        // 添加、修改商品主图-小贴士
        handleTipsPictureAddOrModify(data, index) {
            this.handleTipsPictureSuccess(data, index);
        },
        // 删除商品主图-小贴士
        handleTipsPictureDelete() {
            this.updateField('tipsPicture', null);
            // 从ztPictureList字段中删除“商品主图-小贴士”
            this.form.ztPictureList = this.form.ztPictureList.filter((item) => item.pictureContentType !== 2);
        },
        wmDataHasNoError() {
            const lbNum = this.form.lbPicture ? 1 : 0;
            const yyNum = this.form.yyPicture ? 1 : 0;
            // skuPicture2WmNum:由商品主图同步到外卖图的图片，即所有的主图图片减去gif
            const skuPicture2WmNum = this.form.skuPictureList.length ? (this.form.skuPictureList.length - 1 - this.ztGifNum) : 0;
            // 外卖图数据和数据的关系(外卖图数量=列表图数量+主图数量-1-主图gif图数量)
            return (
            // 外卖图等于列表图(1张+主图4张+营养图1张)
                this.form.wmPictureList.length === lbNum + skuPicture2WmNum + yyNum);
        },
        // 更新外卖图，老逻辑搬运
        updateWmPicList(skuPictureList) {
            let wmPictureList = [];
            let lb = null;
            let yy = null;
            // 有列表图并且外卖图数据正常
            if (this.form.lbPicture) {
                // 有列表图
                lb = imgUrlTransformObject({
                    picUrl: this.form.lbPicture.picUrl,
                    type: operatePicTypeEnum.WM_TYPE,
                    height: NOMAL_HEIGHT,
                });
            }

            // 如果营养图存在,且主图存在,把营养图push到主图列表中,  pictureContentType:1用来区分是营养..
            if (this.form.yyPicture && this.form.yyPicture.pictureContentType === 1 && this.form.yyPicture.picUrl) {
                if (this.form.skuPictureList.length) {
                    if (this.form.skuPictureList[this.form.skuPictureList.length - 1].pictureContentType !== 1) {
                        yy = imgUrlTransformObject({
                            picUrl: this.form.yyPicture.picUrl,
                            type: operatePicTypeEnum.WM_TYPE,
                            height: NOMAL_HEIGHT,
                            pictureContentType: 1,
                        });
                    }
                }
            }

            if (this.form.wmPictureList.length) {
                wmPictureList = this.handleWaimaiList(skuPictureList.slice(1), lb, yy);
            } else {
                wmPictureList = this.handleWaimaiList(skuPictureList.slice(1));
            }

            let count = 0;
            const newWmList = wmPictureList.filter((v) => {
                // 过滤掉gif后缀和picUrl为空的对象
                if (imgIsGif(v.picUrl)) {
                    // eslint-disable-next-line no-plusplus
                    count++;
                }
                return !imgIsGif(v.picUrl) && v.picUrl;
            });
            this.ztGifNum = count;
            return newWmList;
        },
        // 老逻辑搬运
        handleWaimaiList(ztPicList, lbPic, yyPic) {
            // 构造同步后的外卖图list
            const imgList = ztPicList.map((v) => ({
                id: null,
                pictureType: 2,
                picUrl: v.picUrl,
                sequence: v.sequence,
                width: NOMAL_WIDTH,
                height: NOMAL_HEIGHT,
                pictureContentType: v.pictureContentType,
            }));
            if (lbPic) {
                imgList.unshift(lbPic);
            }
            if (yyPic) {
                imgList.push(yyPic);
            }
            return imgList;
        },
        syncWmFirstPicture(data) {
            const {
                picUrl, type, wmDataHasNoError, pictureContentType,
            } = data;
            const imgObj = imgUrlTransformObject({
                picUrl,
                type: operatePicTypeEnum.WM_TYPE,
                height: NOMAL_HEIGHT,
                pictureContentType,
            });
            if (type === 'add') {
                this.form.wmPictureList.unshift(imgObj);
            } else if (type === 'modify') {
                if (wmDataHasNoError) {
                    // 外卖图数据正常的情况
                    this.$set(this.form.wmPictureList[0], 'picUrl', picUrl);
                } else {
                    // 外卖图数据异常
                    this.form.wmPictureList.unshift(imgObj);
                }
            } else if (type === 'addTail') {
                // 往外卖图尾部添加
                this.form.wmPictureList.push(imgObj);
            } else if (type === 'modifyTail') {
                // 修改外卖图尾部数据
                if (wmDataHasNoError) {
                    // 外卖图数据正常的情况
                    this.$set(this.form.wmPictureList[this.form.wmPictureList.length - 1], 'picUrl', picUrl);
                } else {
                    // 外卖图数据异常
                    this.form.wmPictureList.push(imgObj);
                }
            }
        },
        // 动态列表图上传成功
        handleDlbSuccess(picUrl, index) {
            if (picUrl) {
                this.updateField('dlbPicture', imgUrlTransformObject({
                    picUrl,
                    type: operatePicTypeEnum.DLB_TYPE,
                    height: operatePicInfo.NOMAL_HEIGHT,
                    sequence: index,
                }));
            } else {
                this.updateField('dlbPicture', null);
            }
        },
        // 动态列表删除
        handleDlbDelete() {
            this.updateField('dlbPicture', null);
        },
        // 商品主图上传处理
        skuPictureListInput(urlList) {
            skuPictureListInput.call(this, urlList);
        },
        // 商品详情
        handleDescriptionSuccess() {
            this.$refs.form.validate();
        },
        onExtAttrSelected(data) {
            this.form.skuExtAttrList = data;
        },
        goToList() {
            const { from } = this;
            switch (from) {
                case 'informationAndPic':
                    this.$tools.linkTo('/product/createNewProduct/edit/list.html');
                    break;
                case 'process':
                    this.$tools.linkTo('/product/createNewProduct/apply/list.html');
                    break;
                default:
                    this.$tools.linkTo('/product/createNewProduct/list.html');
            }
        },
        getProductBaseApprove() {
            this.$hPost('/api/vss/shepherd/product/queryProductBaseApprovel', {
                spuBaseId: this.spuId,
                auditStaus: 10,
                paging: {
                    offset: 0,
                    limit: 100,
                },
                approvalTypeList: [2, 4],
            }).then((res) => {
                this.originalModifiyAttrs = this.$tools.deepClone(res.data);
                this.getSpuAndSkuApproveAttrs();
            }).catch(() => {
                // pass
            });
        },
        // 获取商品审核操作单
        getSpuAndSkuApproveAttrs() {
            this.modifiyAttrs = [];
            const skuBaseId = this.form.skuBaseId;
            (this.originalModifiyAttrs || []).map((item) => {
                if (item.skuBaseId === +skuBaseId || +item.skuBaseId === 0) {
                    (item.approvalFieldList || []).forEach((app) => {
                        this.modifiyAttrs.push({
                            operator: item.operator,
                            fieldName: app.fieldName,
                            fieldCode: app.fieldCode,
                            fieldDesc: app.fieldDesc,
                        });
                    });
                }
                return this.modifiyAttrs;
            });
        },
        // 提交接口 -> 表单处理（为接口需要的数据）
        handleParams(form) {
            const params = this.$tools.cloneDeep(form);
            // 处理商品卖点：用户可能拖动标签来调整卖点展示顺序，需要重新赋值sequence字段
            params.skuSellPointContentList = (params.skuSellPointContentList || []).map((item, index) => ({
                ...item,
                sequence: index,
            }));
            // 处理商品主图：sequence必须从小到大，而组件内部抛出的sequence有误，这里重新赋值sequence字段
            params.skuPictureList = (params.skuPictureList || []).map((item, index) => ({
                ...item,
                sequence: index,
            }));
            // 处理外卖侧用图：sequence必须从小到大，而组件内部抛出的sequence有误，这里重新赋值sequence字段
            params.wmPictureList = (params.wmPictureList || []).map((item, index) => ({
                ...item,
                sequence: index,
            }));
            // 处理商品主图-小贴士（在主图集合的倒数第2个元素，因此先处理）
            if (params.tipsPicture && params.tipsPicture.pictureContentType === 2) { // 条件一：商品主图-小贴士存在
                params.skuPictureList.push({
                    ...params.tipsPicture,
                    /**
                     * 组件内部会把图片裁剪，这里传递初始图片的分辨率及链接
                    */
                    picUrl: params.tipsPicture?.picUrl || params.tipsPicture?.originalPicUrl,
                    height: 800,
                    width: 800,
                    sequence: params.skuPictureList.length,
                });
            }
            // 处理营养图（在主图集合的倒数第1个元素，因此后处理）
            if (params.yyPicture && params.yyPicture.pictureContentType === 1) { // 条件一：营养图存在
                if (params.skuPictureList[params.skuPictureList.length - 1].pictureContentType !== 1) { // 条件二：主图最后一张不是营养图
                    params.skuPictureList.push(imgUrlTransformObject({ // 以上两个条件成立时，把“营养图”push到主图列表中
                        id: params.yyPicture.id,
                        type: operatePicTypeEnum.ZT_TYPE,
                        picUrl: params.yyPicture.picUrl,
                        originalPicUrl: params.yyPicture.originalPicUrl,
                        height: this.nutritionHeight,
                        pictureContentType: 1,
                        // 之前params.skuPictureList的长度为length，则之前数组各元素的sequence值为0～length-1，该新增项的sequence值顺排为length
                        sequence: params.skuPictureList.length,
                    }));
                }
            }
            // 处理商品详情：将商详的3个字段拼接成1个字段
            const description = (params.topDescription ? JSON.parse(params.topDescription) : [])
                ?.concat(params.mediumDescription ? JSON.parse(params.mediumDescription) : [])
                ?.concat(params.bottomDescription ? JSON.parse(params.bottomDescription) : []);
            params.description = description.length > 0 ? JSON.stringify(description) : '';

            // 补充新版商品主图字段
            params.ztPictureList = params.skuPictureList;
            // 补充skuid
            params.skuId = params.skuBaseId;
            return params;
        },
        clearValidate() {
            this.$refs.form.clearValidate();
        },
        async validate() {
            let validResult = false;
            try {
                validResult = await this.$refs.form.validate();
            } catch (error) {
                // pass
                console.warn('operate content::', error);
            }
            return validResult;
        },
        async onSubmit() {
            const valid = await this.validate();
            if (!valid) return;

            // 提交前触发confirm弹窗校验
            this.triggerConfirmDialog();
        },
        triggerConfirmDialog() {
            this.$refs.confirmDialog._popup({
                ocrValidParams: {
                    scene: 7,
                    skuId: this.skuId,
                    ztPictureList: this.form.skuPictureList,
                    lbPicture: this.form.lbPicture,
                },
            });
        },
        onConfirmSuccess() {
            this.handleRequest();
        },
        async handleRequest() {
            const params = {
                skuContent: this.handleParams(this.form),
                loadTime: this.loadTime,
                oldContentApplyId: this.isSupplierEditAgain ? this.businessKey : +this.contentEditApplyId,
                version: this.version,
            };

            // 临时处理图片尺寸，等图片尺寸全部调整完，可以下掉
            await this.picSizeRewrite(params.skuContent).catch(() => {});
            try {
                this.loading = true;
                await this.$hPost(this.isSupplierEditAgain ? '/api/vss/shepherd/VssContentApplyTService/submitModifySkuContent' : '/api/vss/shepherd/product/submitModifySkuContentFlow', params);
                this.$message.success('提交成功');
                setTimeout(() => {
                    this.goToList();
                }, 1000);
            } catch (error) {
                this.$message.error(error.msg || error.message || '提交失败');
            } finally {
                this.loading = false;
            }
        },
        judgeAttrDisabled(key) {
            return this.cannotChangedFields.includes(key);
        },
        // 提供给新品提报页面使用的方法
        _initForCreateNew(params) {
            this.skuInfo.categoryId = params.categoryId;
            this.skuInfo.bgCategoryId = params.bgCategoryId;
            this.handleForm(params.form);
            // todo 后续优化组件初始化，暂时通过重新渲染解决
            this.skuPictureKey = `skuPictureKey${Math.random()}`;
        },
        _getData() {
            return this.handleParams(this.form);
        },
        onSupplierChange(val, node) {
            this.form.supplierName = (node && node.label) ? node.label : '';
        },
        onSupplierListLoaded(data) {
            if (data && data.length === 1) {
                this.form.supplierId = data[0].value;
            }
        },
        picSizeRewrite(formData) {
            const jobs = [];
            if (formData.lbPicture) jobs.push(updatePicSize([formData.lbPicture]));
            if (formData.wmPictureList && formData.wmPictureList.length) jobs.push(updatePicSize(formData.wmPictureList));
            if (formData.skuPictureList && formData.skuPictureList.length) jobs.push(updatePicSize(formData.skuPictureList));
            return Promise.all(jobs);
        },
        // 列表图同步商品主图
        synchronousPictureList({ picUrl, type }) {
            const imgObj = imgUrlTransformObject({
                picUrl,
                type: operatePicTypeEnum.WM_TYPE,
                height: NOMAL_HEIGHT,
            });

            if (type === 'add') {
                const skuPictureList = this.form.skuPictureList.map((item) => item.picUrl);
                if (this.form.skuPictureList && this.form.skuPictureList.length < 6) {
                    skuPictureList.unshift(imgObj.picUrl);
                } else {
                    skuPictureList[0] = imgObj.picUrl;
                }
                this.skuPictureListInput(skuPictureList);
                this.$refs.dragfileupload.initImgArray(skuPictureList);
            } else {
                // 修改同步至商品主图
                if (this.form.skuPictureList && this.form.skuPictureList.length) {
                    this.$set(this.form.skuPictureList[0], 'picUrl', picUrl);
                    this.$refs.dragfileupload.initImgArray(this.form.skuPictureList.map((items) => items.picUrl));
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.operate-content {
    margin-bottom: 50px;
    padding: 0 20px;
    /deep/ .el-select {
        width: 100%;
    }
    /deep/ .el-input {
        width: 100% !important;
    }
    /deep/ .video-upload /deep/ .el-upload {
        width: auto;
    }
    .el-form-item__counter {
        // text-align: right;
        // vertical-align: middle;
        float: left;
        font-size: 12px;
        color: #48576a;
        line-height: 1;
        padding: 20px 12px 0px 12px;
        box-sizing: border-box;
    }
    .product-video-container{
        display:flex;
        align-items:flex-end;
    }
    .product-video-container {
        float: left;
        /deep/ .el-upload-dragger {
            margin: 0 !important;
        }
    }
    // .tip {
    //     margin: 0;
    // }
    .el-alert {
        background-color: #fff2e6;
        color: #ff8000;
    }
    .need-align {
        display: flex;
        height: 33px;
        align-items: center;
        justify-content: flex-start;
    }
    .sub-title-input {
        width: 80% !important;
    }
}
.footer {
    line-height: 40px;
    padding: 5px 0;
    background-color: #eee;
    text-align: center;
    position: fixed;
    bottom: 0;
    width: 100%;
}
.prompt-text {
    color: black;
    margin-left: 5px;
}
.prompt-text:hover {
    cursor: help;
}
.max-width-900 {
    max-width: 900px;
}
.w-full {
    width: 100%;
}
.text-info {
    color: #95989E;
    width: 800px;
}
.main-picture {
    display:flex;
}
.main-picture-describe {
    margin-left: 100px;
}
.nutrition-picture-describe {
    p{
        margin: 0;
    }
}
.flex-column-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.mt-33 {
    margin-top: 33px;
}
.ml-10 {
    margin-left: 10px;
}
.sample{
    width: 100px;
    height: 100px;
    margin-bottom:10px;
}
.first-child {
    margin-top: 60px;
}
.last-child {
    margin-bottom: 0 !important;
}
</style>
